import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * App Errors / Logs viewer. Log tailing runs server-side via the
 * `check_app_logs` background job (which alerts devs on new error lines); an
 * interactive raw-log/REST-log viewer needs a log-read endpoint + a durable log
 * sink, which is an infra concern surfaced here as a seam (spec §12).
 */
export default function ErrorsPage() {
  return (
    <div className="flex flex-col gap-6">
      <Alert>
        <AlertTitle>Log monitoring runs as a background job</AlertTitle>
        <AlertDescription>
          The <strong>check_app_logs</strong> job scans the app log every 10 minutes and alerts the
          configured dev recipients on new error/critical lines (see the Jobs console). An
          interactive raw-log / REST-log viewer requires a durable log sink + read endpoint (infra
          concern) and is intentionally deferred.
        </AlertDescription>
      </Alert>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Where to look now</CardTitle>
        </CardHeader>
        <CardContent className="text-muted-foreground text-sm">
          Run <code>check_app_logs</code> from the Jobs console to force a scan; its JobRun summary
          reports how many new error lines were seen since the last offset.
        </CardContent>
      </Card>
    </div>
  );
}
